export enum WindowSizesEnum {
  DESKTOP = "break-desktop",
  LAPTOP = "break-laptop",
  LAPTOP_SM = "break-laptop-sm",
  TABLET_LANDSCAPE = "break-md",
  TABLET_PORTRAIT = "break-sm",
  MOBILE = "break-xs"
}
